import { useEffect, useState } from 'react';

import clsx from 'clsx';
import has from 'lodash/has';
import map from 'lodash/map';
import qs from 'qs';

import analytics from '../../analytics';
import Footer from '../Footer';
import Logo from '../Logo';

import './IneligibleView.css';

const urlParams = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});

function errorInfo() {
  if (!has(urlParams, 'code')) {
    return (
      <>
        <p className="IneligibleView-info" data-testid="IneligibleView-info">
          You have the right to request any personal information about you that
          is in our records, including any investigative consumer report we have
          obtained. You also have the right to receive a copy of this
          information and to request that we correct, amend or delete any of the
          information that you feel is in error.
        </p>
        <p className="IneligibleView-info">
          You may contact us at{' '}
          <a href="mailto:support@gettoggle.com">support@gettoggle.com</a> for
          additional information on your ineligibility.
        </p>
      </>
    );
  }
  switch (urlParams.code) {
    case 'bite_history':
      return (
        <>
          <p
            className="IneligibleView-info"
            data-testid="IneligibleView-info-pet"
          >
            Unfortunately, because you indicated that you have a pet with a
            history of biting, we are unable to provide you with coverage at
            this time.
          </p>
          <p className="IneligibleView-info">
            If you have any questions please contact us at{' '}
            <a href="https://www.gettoggle.com" rel="noopener nofollow">
              www.gettoggle.com
            </a>
            .
          </p>
        </>
      );
    case 'loss_history':
      return (
        <>
          <p
            className="IneligibleView-info"
            data-testid="IneligibleView-info-lossHistory"
          >
            You are currently not eligible for coverage with Toggle based on
            information contained in a loss history report, which we obtained
            from the consumer reporting agency shown below.
          </p>
          <p className="IneligibleView-info">
            If you have any questions about the specific reason(s) for your
            ineligibility for coverage, you may contact us at{' '}
            <a href="mailto:support@gettoggle.com">support@gettoggle.com</a>.
          </p>
          <div className="IneligibleView-bgDivider" />
        </>
      );
    default:
      return null;
  }
}

const lossHistoryStates = [
  {
    title: 'AZ',
    desription: (
      <p className="IneligibleView-lossHistory">
        <h2 className="IneligibleView-lossHistory-subheading">
          Important State Specific Information
        </h2>
        The following Summary of Rights was provided by the Arizona Department
        of Insurance and summarizes rights set forth in Arizona statutes
        20-2108, 20-2109, 20-2110. Arizona law considers it an “adverse
        underwriting decision” if we decide to decline your application, charge
        a higher rate based on information which differs from that which you
        provided in your Insurance Application and any additional information
        that you may have provided, assign you to a higher rating tier or fail
        to apply a premium discount or credit based on any credit related
        information derived from your consumer report, insurance score or lack
        of credit history, or terminate your insurance coverage (except for
        failure to pay premium).
        <br />
        <br />
        Any written requests referenced below should be directed to:
        <br />
        Toggle
        <br />
        PO Box 248925
        <br />
        Oklahoma City, OK 73124-8925
        <br />
        <br />
        <h2 className="IneligibleView-lossHistory-subheading">
          Your Rights Following an Adverse Underwriting Decision
        </h2>
        Within 90 business days from the date of the mailing of the notice to
        you of an adverse underwriting decision, we will furnish to you within
        21 business days from the date of receipt of{' '}
        <div className="IneligibleView-lossHistory-subheading-underline">
          the written request from you:
        </div>
        <br />
        <br />
        <div className="IneligibleView-lossHistory-sortedList">
          1. The specific reason for the adverse underwriting decision if the
          information was not initially furnished in writing, and
          <br />
          2. The specific items of personal and privileged information that
          support those reasons except that:The Company will disclose the
          specific items of medical record information supplied by a medical
          care institution or medical professional either directly to the
          individual about whom the information relates or to a medical
          professional designated by the individual and licensedto provide
          medical care with respect to the condition to which the information
          relates.The Company will disclose the names and addresses of the
          institutional sources that supplied the specific items of personal or
          privileged information except that we shall identify the medical
          professional or medical care institution either directly to the
          individual or to the designated medical professional.
        </div>
        <br />
        <br />
        <h2 className="IneligibleView-lossHistory-subheading">
          Your Rights to Access your Recorded Personal Information
        </h2>
        You have the right to submit a written request for access to your
        recorded personal information.
        <br />
        <br />
        Within 30 business days of the receipt of your request for access to
        your recorded personal information, will inform you of the nature and
        substance of the recorded personal information.
        <br />
        <br />
        You have the right to see and copy, in person, the recorded personal
        information, or obtain a copy by mail, whichever you prefer.
        <br />
        <br />
        The Company will disclose to you the identity, if recorded, of those
        persons to whom the Insurance Support Organization has disclosed the
        personal information within two years prior to your request; if not
        recorded, the names of those institutions or persons to whom the
        information is normally disclosed.
        <br />
        <br />
        Any of the personal information provided to you will identify the source
        if it is an institutional source.
        <br />
        <br />
        The Company shall provide medical record information supplied by a
        medical care institution or medical professional, along with identity of
        the medical professional or medical care institution which provided the
        information, either directly to you or to a medical professional
        designated by you, who is licensed to provide medical care with respect
        to the condition to which the information relates. We will notify you if
        it elects to disclose the information to a medical professional
        designated by you.
        <br />
        <br />
        <h2 className="IneligibleView-lossHistory-subheading">
          Your Rights to Correction, Amendment, or Deletion of Recorded Personal
          Information
        </h2>
        Within 30 business days of the receipt of a written request from you to
        correct, amend, or delete any personal information about you, the
        company, or insurance support organization shall either:
        <br />
        <br />
        <div className="IneligibleView-lossHistory-sortedList">
          1.Correct, amend, or delete the portion of the recorded personal
          information in dispute;
          <br />
          2.Notify you of our refusal to make the correction, amendment, or
          deletion, the reasons for the refusal, and your right to file a
          statement if you disagree.
        </div>
        <br />
        <br />
        If the company or insurance support organization corrects, amends, or
        deletes recorded personal information, the company or insurance support
        organization will notify you in writing and furnish the correction,
        amendment, or fact of deletion to any person specifically designated by
        you who may have, within the preceding two years, received the recorded
        personal information.
        <br />
        <br />
        If you disagree with the company’s or insurance support organization’s
        refusal to correct, amend, or delete recorded personal information, you
        may file with the company or insurance support organization a concise
        statement setting forth what you think is the correct, relevant, or fair
        information and a concise statement of the reasons why you disagree with
        the company’s or insurance support organization’s refusal to correct,
        amend, or delete recorded personal information. Your responsewill be
        added to your file.
      </p>
    ),
  },
  {
    title: 'CA, CT, GA, IL, KS, MN, MT, NV, OR',
    desription: (
      <p className="IneligibleView-lossHistory">
        If you believe your personal information is incorrect, you may write to
        us to ask us to correct, amend or delete the disputed information. After
        we review your request, we will make the appropriate changes. If we
        cannot make the changes you request, you can file a statement outlining
        why you disagree with our decision. We will include a copy of your
        statement in our policy file so anyone reviewing your information will
        have access to it. In addition, at your request, we will also provide a
        copy of your statement to anyone who may have received your information
        from us in the previous two years.
        <br />
        <br />
        Any written requests should be directed to:
        <br />
        <br />
        Toggle
        <br />
        PO Box 248925
        <br />
        Oklahoma City, OK 73124-8925
      </p>
    ),
  },
  {
    title: 'VA',
    desription: (
      <p className="IneligibleView-lossHistory">
        In connection with your application for or policy of renters insurance,
        we have found it necessary to take the following action: your
        application for insurance is declined.
        <br />
        <br />
        You have a right to obtain the specific reason(s) for this decision by
        submitting a written request to the company.
        <br />
        <br />
        If you ask us to correct, amend, or delete any information about you in
        our files and if we refuse to do so, you have the right to give us a
        concise statement of what you believe is the correct information. We
        will put your statement in our file so that anyone reviewing your file
        will see it.
        <br />
        <br />
        If you would like additional information concerning this action, state
        law requires that you submit a written request within ninety (90)
        business days of the date this notice was mailed to you. Please send
        your request to:
        <br />
        <br />
        Toggle
        <br />
        PO Box 248925
        <br />
        Oklahoma City, OK 73124-8925
      </p>
    ),
  },
];

function IneligibleView({ isLoggedIn }) {
  const [openLossHistory, setOpenLossHistory] = useState({});
  useEffect(() => {
    analytics.page();
  }, []);

  function toggleLossHistory(key) {
    const updateToggle = { [key]: !openLossHistory[key] };
    setOpenLossHistory({ ...openLossHistory, ...updateToggle });
  }

  function lossHistoryStatesSection() {
    return map(lossHistoryStates, (lossHistoryState, i) => {
      const key = `lossHistoryState-${i}`;
      const isOpen = !!openLossHistory[key];

      return (
        <li
          key={key}
          className={clsx('IneligibleView-lossHistory-section', {
            'is-open': isOpen,
          })}
        >
          <h3
            className="IneligibleView-lossHistory-title"
            onClick={() => toggleLossHistory(key)}
          >
            {lossHistoryState.title}
            <i
              className={clsx('IneligibleView-lossHistory-title-icon fas', {
                'fa-caret-down': !isOpen,
                'fa-caret-up': isOpen,
              })}
            />
          </h3>
          {lossHistoryState.desription}
        </li>
      );
    });
  }

  const isLossHistory =
    has(urlParams, 'code') && urlParams.code === 'loss_history';

  return (
    <div className="IneligibleView">
      <div
        className="IneligibleView-bgWrapper"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/ineligible-bg.svg)`,
        }}
      >
        <div className="IneligibleView-container">
          <Logo overrideClasses={{ root: 'IneligibleView-logo' }} />
          <h2 className="IneligibleView-heading">
            We&apos;re sorry but you are not currently eligible for coverage
            with Toggle.
          </h2>
          {errorInfo()}
        </div>
      </div>
      {isLossHistory && (
        <div className="IneligibleView-lossHistory-container">
          <h3 className="IneligibleView-lossHistory-title">
            Verisk Insurance Solutions
          </h3>
          <p className="IneligibleView-lossHistory">
            You may contact the A-PLUS Consumer Report Request Line at{' '}
            <strong>
              <a
                href="tel:1-800-627-3487"
                className="IneligibleView-lossHistory"
              >
                1-800-627-3487
              </a>
            </strong>{' '}
            to request your free A-PLUS loss history report.
            <br />
            <br />
            You may also visit{' '}
            <strong>
              <a
                className="IneligibleView-lossHistory"
                href="https://fcra.verisk.com/"
              >
                https://fcra.verisk.com/
              </a>
            </strong>{' '}
            or write to:
            <br />
            Verisk Insurance Solutions Consumer Inquiry Center
            <br />
            P.O. Box 5404
            <br />
            Mt. Laurel, NJ 08054
            <br />
            <br />
            Under the Fair Credit Reporting Act, you have a right to obtain a
            free copy of your report from any consumer reporting agency shown
            above. This request must be made no later than 60 days after you
            receive this notice. In addition, if you find any inaccurate or
            incomplete information in the report, you may dispute the report
            with the consumer reporting agency. Please note the consumer
            reporting agency provided the report but did not make any decision
            to take adverse action and is unableto provide the specific reasons
            why adverse action was taken.
            <br />
            <br />
            You have the right to request any personal information about you
            that is in our records, including any investigative consumer reports
            we have obtained. You also have a right to receive a copy of this
            information and to request that we correct, amend or delete any of
            the information that you feel is in error.
            <br />
            <br />
            If you have any questions about the specific reason(s) for your
            ineligibility for coverage, you may contact us at{' '}
            <strong>
              <a
                className="IneligibleView-lossHistory"
                href="mailto:support@gettoggle.com"
              >
                support@gettoggle.com
              </a>
            </strong>{' '}
            <br />
            <br />
            <h3 className="IneligibleView-lossHistory-subheading">
              For more state specific information please click on your state:
            </h3>
          </p>
          {lossHistoryStatesSection()}
        </div>
      )}
      <Footer isLoggedIn={isLoggedIn} />
    </div>
  );
}

export default IneligibleView;
